export default __webpack_public_path__ + "static/images/plugin-om.png?47c0b4663d97ae6d41bad01d2d6f0812";